import { render, staticRenderFns } from "./DetailsTabButton.vue?vue&type=template&id=691ede30&scoped=true&"
import script from "./DetailsTabButton.vue?vue&type=script&lang=js&"
export * from "./DetailsTabButton.vue?vue&type=script&lang=js&"
import style0 from "./DetailsTabButton.vue?vue&type=style&index=0&id=691ede30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691ede30",
  null
  
)

export default component.exports